export function reshapeMonthlyStockData(rawStockArray) {
    const reshaped = [];

    if (!rawStockArray || rawStockArray.length === 0) return reshaped;

    // Get the number of months/weeks from the length of any "val" array
    const length = rawStockArray[0].val.length;

    for (let i = 0; i < length; i++) {
        const entry = {
            month: i + 1,
            //year: 2024  // Change this logic if you get year dynamically
            year: 2025
        };

        rawStockArray.forEach(item => {
            const key = item.input_name;
            entry[key] = item.val[i];
        });

        reshaped.push(entry);
    }

    return reshaped;
}

export function reshapeWeeklyStockData(rawStockArray) {
    const reshaped = [];

    if (!rawStockArray || rawStockArray.length === 0) return reshaped;

    const length = rawStockArray[0].val.length;

    for (let i = 0; i < length; i++) {
        const entry = {};

        rawStockArray.forEach(item => {
            const key = item.input_name;
            entry[key] = item.val[i];
        });

        reshaped.push(entry);
    }

    return reshaped;
}

export function transformDriversData(driverArray = []) {
    const result = {};
    driverArray?.forEach(({ input_name, val }) => {
        result[input_name] = val;
    });
    return result;
}

export function transformInputsData(inputList) {
    const result = {};
    inputList?.forEach(item => {
        if (item.input_name && Array.isArray(item.val)) {
            result[item.input_name] = item.val;
        }
    });
    return result;
}



